// extracted by mini-css-extract-plugin
module.exports = {"video-containter":"video-containter","video-content":"video-content","video-close":"video-close"};